import * as actionTypes from '../actions/actionTypes';
import {
    updateObject
} from '../../shared/utility';


const initialState = {
    IOTssidNetwork: {},
    IOTssidNetworkSuccess: false,
    IOTssidNetworkFail: false,
    IOTssidNetworkLoading: false,
    IOTssidFailureMesssage: '',
    IOTssidNetworkSuccessMessage: '',
    createIOTssidNetworkFailed: false,
    createIOTssidNetworkSuccess: false,
    IOTssidNetworkFailMsg: "",
    networks: [],
    networksLoading: false,
    networksLoaded: false,
    networksError: false,
    selectedNetwork: null,
    networkDevices: [],
    networkDevicesLoading: false,
    networkDevicesLoaded: false,
    networkDevicesError: false,
    updateNetworkLoading: false,
    updateNetworkSuccess: false,
    updateNetworkError: false,
    deleteNetworkLoading: false,
    deleteNetworkSuccess: false,
    deleteNetworkError: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CREATE_IOT_SSID_NETWORK_LOADING:
            return updateObject(state, {
                createIOTssidNetwork: {},
                createIOTssidNetworkLoading: action.isLoading,
            });
            
        case actionTypes.CREATE_IOT_SSID_NETWORK_SUCCESS:
            return updateObject(state, {
                createIOTssidNetwork: action.payload?.network || {},
                createIOTssidNetworkLoading: false,
                createIOTssidNetworkFailed: false,
                createIOTssidNetworkSuccess: true,
            });

        case actionTypes.CREATE_IOT_SSID_NETWORK_FAILED:
            return updateObject(state, {
                createIOTssidNetwork: {},
                createIOTssidNetworkFailed: true,
                createIOTssidNetworkLoading: false,
                createIOTssidNetworkSuccess: false,
                IOTssidNetworkFailMsg: action.payload?.message
            });
        case actionTypes.GET_IOT_SSID_NETWORK_LOADING:
            return updateObject(state, {
                createIOTssidNetwork: {},
                createIOTssidNetworkLoading: action.isLoading
                }); 

        case actionTypes.GET_IOT_SSID_NETWORK_SUCCESS:
            return updateObject(state, {
                getIOTssidNetwork: action.payload || {},
                getIOTssidNetworkLoading: false,
                getIOTssidNetworkSuccess: true,
                });

         case actionTypes.GET_IOT_SSID_NETWORK_FAILED:
             return updateObject(state, {
                getIOTssidNetwork: {},
                getIOTssidNetworkFail: true,
                getIOTssidNetworkSuccess : false,
             }); 
        case actionTypes.GET_IOT_SSID_NETWORK_DEVICES_FAILED:
            return updateObject(state, {
                getIOTssidNetworkDevices: {},
                getIOTssidNetworkDevicesFail: true,
                getIOTssidNetworkDevicesSuccess : false,
            });
        case actionTypes.GET_IOT_SSID_NETWORK_DEVICES_SUCCESS:
            return updateObject(state, {
                getIOTssidNetworkDevices: action.payload || {},
                getIOTssidNetworkDevicesFail: false,
                getIOTssidNetworkDevicesSuccess : false,
            });

        case actionTypes.GET_ALL_IOT_SSID_NETWORK_DETAILS_LOADING:
            return updateObject(state, {
                IOTssidNetwork: {},
                IOTssidNetworkLoading: action.isLoading
                }); 

        case actionTypes.RESET_IOT_SSID_ERROR_SUCCESS:
                    return updateObject(state , {
                        IOTSsidNetworkSuccess: false,
                        IOTSsidNetworkFail: false,
                        IOTSsidNetworkSuccessMessage: '',
                        IOTSsidDeleteFailureMesssage: '',
                        IOTSsidFailureMesssage: '',
                        createIOTssidNetworkFailed: false,
                        createIOTssidNetworkSuccess: false
                        });

        // Networks
        case actionTypes.GET_NETWORKS_LOADING:
            return updateObject(state, { networksLoading: true, networksLoaded: false, networksError: false });
        case actionTypes.GET_NETWORKS_SUCCESS:
            return updateObject(state, { networksLoading: false, networksLoaded: true, networksError: false, networks: action.payload });
        case actionTypes.GET_NETWORKS_FAIL:
            return updateObject(state, { networksLoading: false, networksLoaded: false, networksError: true });
        case actionTypes.SET_SELECTED_NETWORK:
            return updateObject(state, { selectedNetwork: action.payload, networkDevices: [] });
        case actionTypes.GET_NETWORK_DEVICES_LOADING:
            return updateObject(state, { networkDevicesLoading: true, networkDevicesLoaded: false, networkDevicesError: false });
        case actionTypes.GET_NETWORK_DEVICES_SUCCESS:
            return updateObject(state, { networkDevicesLoading: false, networkDevicesLoaded: true, networkDevicesError: false, networkDevices: action.payload });
        case actionTypes.GET_NETWORK_DEVICES_FAIL:
            return updateObject(state, { networkDevicesLoading: false, networkDevicesLoaded: false, networkDevicesError: action.payload || true, networkDevices: [] });
        case actionTypes.UPDATE_NETWORK_LOADING:
            return updateObject(state, { updateNetworkLoading: true, updateNetworkSuccess: false, updateNetworkError: false });
        case actionTypes.UPDATE_NETWORK_SUCCESS:
            return updateObject(state, { updateNetworkLoading: false, updateNetworkSuccess: true, updateNetworkError: false });
        case actionTypes.UPDATE_NETWORK_FAIL:
            return updateObject(state, { updateNetworkLoading: false, updateNetworkSuccess: false, updateNetworkError: true });
        case actionTypes.CLEAR_UPDATE_NETWORK_ERROR:
            return updateObject(state, { updateNetworkError: false });
        case actionTypes.DELETE_NETWORK_LOADING:
            return updateObject(state, { deleteNetworkLoading: true, deleteNetworkSuccess: false, deleteNetworkError: false });
        case actionTypes.DELETE_NETWORK_SUCCESS:
            return updateObject(state, { deleteNetworkLoading: false, deleteNetworkSuccess: true, deleteNetworkError: false, selectedNetwork: null, networkDevices: [] });
        case actionTypes.DELETE_NETWORK_FAIL:
            return updateObject(state, { deleteNetworkLoading: false, deleteNetworkSuccess: false, deleteNetworkError: true });
       
        default: return state;
    }
};
export default reducer;
